export default __webpack_public_path__ + "static/media/2093.72f8b586.png";